import React, { useRef, useState } from "react";
import styles from "./footer.module.scss";
import { MessageHelper } from "../../helpers/MessageHelper";
import { ReactComponent as Logo } from "./vhv-logo.svg";
import { Link } from "react-router-dom";
import LightweightAnchor from "../anchor/LightweightAnchor";
import LightweightButton from "../button/LightweightButton";
import { VhvPopup } from "@vhv/ui-kit-react";
const staticConfig = require("../../static.config.json");
const footerClasses = `${styles.footerContainer} ${styles.containerFluid}`;
const footerRightClasses = `${styles.flexItem} ${styles.footerRight}`;
const footerLeftClasses = `${styles.flexItem} ${styles.footerLeft}`;
export const Footer = () => {
    const [isPopupVisible, setPopupVisible] = useState(true);
    const popupRef = useRef(null);
    const togglePopup = () => {
        setPopupVisible(!isPopupVisible);
        if (popupRef.current) {
            popupRef.current.toggle();
        }
    };
    const handleMailtoClick = () => {
        window.location.href = "mailto:hotline@vhv.de";
    };
    return React.createElement(React.Fragment, null,
        React.createElement("hr", { className: styles.footerSeparator }),
        React.createElement("div", { id: "footer-container", className: footerClasses },
            React.createElement("div", { id: "footer-left", className: footerLeftClasses },
                React.createElement(Link, { className: styles.fullWidth, to: "/", "aria-label": "logo" },
                    React.createElement(Logo, { className: styles.vhvLogo, preserveAspectRatio: "xMidYMid meet" }))),
            React.createElement("div", { id: "footer-right", className: footerRightClasses },
                React.createElement(VhvPopup, { className: styles.popupContainer, ref: popupRef, id: "contact-popup" },
                    React.createElement("a", { className: styles.serviceDeskTelLink, href: "tel:0511/907-8595" }, "0511 / 907-8595"),
                    React.createElement("p", { className: styles.serviceDeskTitle }, "Vermittler-Help-Desk"),
                    React.createElement("p", { className: styles.serviceDeskTimes }, "Mo. - Fr. 09:00 - 17:00 Uhr"),
                    React.createElement(LightweightButton, { className: styles.backgroundPrimary, onClick: handleMailtoClick, color: "primary", icon: "Mail" }, "hotline@vhv.de")),
                React.createElement(LightweightButton, { id: "contact-popup-button", className: `${styles.marginRight} ${styles.fontOverwrite}`, textButton: true, onClick: togglePopup },
                    React.createElement(MessageHelper, { msgKey: "contactLink" })),
                "/",
                React.createElement(LightweightAnchor, { className: styles.marginRight, href: staticConfig.faq, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(MessageHelper, { msgKey: "faqLink" })),
                "/",
                React.createElement(LightweightAnchor, { className: styles.marginRight, href: staticConfig.dataProtectionPolicy, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(MessageHelper, { msgKey: "dataProtectionLink" })),
                React.createElement(LightweightAnchor, { className: styles.marginRight, href: staticConfig.generalTerms, target: "_blank", rel: "noopenernoreferrer" },
                    React.createElement(MessageHelper, { msgKey: "generalTermsLink" })),
                "/",
                React.createElement(LightweightAnchor, { className: styles.marginRight, href: staticConfig.legalNotice, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(MessageHelper, { msgKey: "legalNoticeLink" })))));
};
